import {
  apiDELETE,
  apiGET,
  apiPOST,
  apiPUT
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/playerBankAccounts.ts
var createBankAccountV2 = async (data) => {
  return await apiPOST("/player/bank-accounts/v2", data, {
    hasNestedData: false
  });
};
var updateDefaultBankAccount = async (id) => {
  return await apiPUT(`/player/bank-accounts/${id}/default`, null, {
    hasNestedData: false
  });
};
var deleteBankAccount = async (id) => {
  return await apiDELETE(`/player/bank-accounts/${id}`, null, {
    hasNestedData: false
  });
};
var getLivenessBankAccount = async (bankAccountId) => {
  const body = { bankAccountId };
  return await apiPOST("/player/bank-accounts/liveness", body, {
    hasNestedData: false
  });
};
var getPlayerBankAccountStatus = async () => {
  return await apiGET("/player/bank-accounts", null);
};
var requestLivenessProcess = async (reUseApproved) => {
  const options = reUseApproved ? { params: { reUseApproved } } : void 0;
  return await apiPOST(
    "/player/bank-accounts/v2/liveness",
    null,
    void 0,
    options
  );
};

export {
  createBankAccountV2,
  updateDefaultBankAccount,
  deleteBankAccount,
  getLivenessBankAccount,
  getPlayerBankAccountStatus,
  requestLivenessProcess
};
